import {
  GET_PROJECTS_LIST,
  GET_PROJECTS_LIST_FAILED,
  DELETE_PROJECT_BY_ID,
  GET_PROJECT_BY_ID,
  GET_SALES_PERSONS_LIST,
  GET_CONTACTS,
  GET_CONTACTS_FAILED
} from '../../actions/projects';

export default function projects(state = {salesPersonsList:[]}, action) {
  switch (action.type) {
    case GET_CONTACTS:
      return Object.assign({}, state, action.payload);
    case GET_PROJECTS_LIST:
      return Object.assign({}, state, action.payload);
    case GET_PROJECTS_LIST_FAILED:
      return Object.assign({}, state, action.payload);
    case DELETE_PROJECT_BY_ID:
      for (let i = 0; i < state.list.length; i++) {
        if (state.list[i].id == action.payload.id) {
          state.list.splice(i, 1);
        }
      }
      return Object.assign({}, state, action.payload);
    case GET_PROJECT_BY_ID:
      return Object.assign({}, state, action.payload);
    case GET_SALES_PERSONS_LIST:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/projects/index.js